import {Component} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";

@Component({
  templateUrl: "./create-work-orders.template.pug",
})

export class CreateWorkOrders extends WorkflowStep {
  public error: Error;
  public deploymentId: string;

  public autoSave(): Promise<boolean> {
    this.error = undefined;
    return Promise.resolve(true);
  }

  public ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.loading = false;
    this.deploymentId = workflowTargetInfo.targetId;
  }

  public checkDirty(): boolean {
    return false;
  }

  setComplete() {
    this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super(true);
  }
}
